export const toggleMode = (mode) => {
    return {
        type: 'update',
        payload: mode
    }
}